import React from 'react';

const DefaultNotFound = () => (
  <h1 className="pt-20 text-center h60 text-3xl text-red-500 font-bold">
    Error, this page doesn&apos;t exist. Sorry.
  </h1>
);

export default DefaultNotFound;
